import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useAIAssistant } from '@/contexts/ai-assistant-context';

export function AIAssistantButton() {
  const { isOpen, togglePanel, unreadCount, isProcessing, markAsRead } = useAIAssistant();

  const handleClick = () => {
    if (!isOpen) {
      markAsRead();
    }
    togglePanel();
  };

  const showWorkingIndicator = isProcessing && !isOpen;
  const showReadyIndicator = !isProcessing && unreadCount > 0 && !isOpen;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="relative">
            <Button
              variant={isOpen ? 'default' : 'outline'}
              size="sm"
              className="gap-2 transition-all"
              onClick={handleClick}
            >
              <Sparkles className="h-4 w-4" />
              <span className="hidden sm:inline">AI</span>
            </Button>
            {showWorkingIndicator && (
              <span 
                className="ai-indicator ai-indicator-working"
                aria-label="AI is processing"
              />
            )}
            {showReadyIndicator && (
              <span 
                className="ai-indicator ai-indicator-ready"
                aria-label="AI has results ready"
              />
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-sm">
            {isOpen ? 'Close AI Assistant' : 'Open AI Assistant'}
            {showWorkingIndicator && ' (Processing...)'}
            {showReadyIndicator && ' (Results ready)'}
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Press <kbd className="px-1 py-0.5 text-xs bg-muted rounded">⌘J</kbd> or <kbd className="px-1 py-0.5 text-xs bg-muted rounded">Ctrl+J</kbd>
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
